import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

import { getUserManager } from '../../libs/auth';
import { LocalStorageManager } from '../../libs/utils';

const Callback = () => {
  const navigate = useNavigate();
  // Guard against double-mounted effects consuming the auth code twice.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    getUserManager()
      .signinRedirectCallback()
      .then(() => {
        const redirectTo = LocalStorageManager.getRedirectUrlOnReturn();
        LocalStorageManager.removeRedirectUrlOnReturn();
        let url = '/';

        // Clean up legacy AAD flag — no longer needed with Code flow
        localStorage.removeItem('aad');

        if (redirectTo != null) {
          url = redirectTo;
        }
        navigate(url, { replace: true });
      })
      .catch(() => navigate('/', { replace: true }));
  }, []);

  return <div>Redirecting...</div>;
};

export default Callback;
